module.exports = __webpack_public_path__ + "img/Traccar_settings.f8f8fc24.png";